import './jsonViewer.css';
import { useEffect, useState } from 'react';

const JsonViewer = (props) => {
    const [jsonString, setJsonString] = useState('');
    useEffect(() => {
        const updatedJsonString = JSON.stringify(props.data, null, 2);
        setJsonString(updatedJsonString);
    }, [props.data]);
    
    return (
        <div className="jsonContainer">
            <pre>
                <code>{jsonString}</code>
            </pre>
        </div>
    )
}

export default JsonViewer;